import { render, staticRenderFns } from "./Tiempos.vue?vue&type=template&id=147f1b08&"
import script from "./Tiempos.vue?vue&type=script&lang=js&"
export * from "./Tiempos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports